export enum FaqImportExportEndpoints {
  IMPORT = '/faq-import',
  EXPORT = '/faq-export',
}

export enum FaqExportScope {
  GENERAL = 'general',
  CHANNEL = 'channel',
  ALL = 'all',
}

export interface IFaqImportErrorRow {
  row: number;
  column: string;
  message: string;
}

export interface IFaqImportResponse {
  dryRun: boolean;
  importDigest: string;
  totalRows: number;
  toCreate: number;
  toUpdate: number;
  skipped: number;
  errorRows: number;
  errors: IFaqImportErrorRow[];
}

export interface IImportFaqsDTO {
  file: File;
  dryRun: boolean;
  importDigest?: string;
  isGeneral: boolean;
  channelId?: number;
}

export interface IPreviewFaqImportDTO {
  file: File;
  isGeneral: boolean;
  channelId?: number;
}

export interface IApplyFaqImportDTO {
  file: File;
  importDigest: string;
  isGeneral: boolean;
  channelId?: number;
}

export interface IFaqExportDTO {
  scope: FaqExportScope;
  channelId?: number;
  question?: string;
  answer?: string;
}
